// @flow

// Vendors
import React from 'react';

// Types
type Props = {
  clearFilters: Function
};

const ProductsEmpty = ({ clearFilters }: Props) => (
  <div className="section section--xs u--text-align-center">
    <div className="grid grid--center">
      <div className="grid__col-md-8">
        <h3 className="h2">No Matching Products.</h3>
        <p>
          Your search didn't return any results. Please adjust the filters to
          see some products.
        </p>
        <button
          type="button"
          className="btn btn--primary"
          onClick={clearFilters}
        >
          Clear Filters
        </button>
      </div>
    </div>
  </div>
);

export default ProductsEmpty;
